module.exports = __webpack_public_path__ + "static/img/10.afbfbf6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/companies/huegler/10.jpg
// module id = 384
// module chunks = 1